/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigSearchRequestModel } from '../../models/config-search-request-model';
import { TermsConditionsSearchResultModel } from '../../models/terms-conditions-search-result-model';

export interface TermsConditionsSearchPost$Params {
      body?: ConfigSearchRequestModel
}

export function termsConditionsSearchPost(http: HttpClient, rootUrl: string, params?: TermsConditionsSearchPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TermsConditionsSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, termsConditionsSearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<TermsConditionsSearchResultModel>>;
    })
  );
}

termsConditionsSearchPost.PATH = '/TermsConditions/Search';
